import styled from 'styled-components'
import LabeldCheckbox from '../common/LabeldCheckbox'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Conatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`
const ArrowIcon = styled(ArrowForwardIosIcon)`
  color: ${(props) => props.theme.colors.neutral[400]};
  cursor: pointer;
`
const TermsItem = ({ label, checked, onChange, onOpen, showArrow = true}) => {
  return (
    <Conatiner>
      <LabeldCheckbox 
        label={label}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}/>
      {showArrow && <ArrowIcon onClick={onOpen}/>}
    </Conatiner>
  )
}

export default TermsItem
